import C from 'actionTypes'

const defaultState = {
  financialAccounts: [],
  financialAccountsCollapsed: {},
}

const financialAccounts = (state = defaultState, action) => {
  switch (action.type) {
    case C.SET_FINANCIAL_ACCOUNTS: {
      const { data } = action

      return {
        ...state,
        financialAccounts: data,
      }
    }

    case C.EDIT_FINANCIAL_ACCOUNT: {
      const { data: { data } } = action
      const { id } = data

      const financialAccounts = state.financialAccounts.map((account) => {
        if (account.id === id) {
          return data
        }
        return account
      })

      return {
        ...state,
        financialAccounts,
      }
    }

    case C.SET_FINANCIAL_ACCOUNT_COLLAPSED: {
      const { data: { financialAccountId, collapsed } } = action

      return {
        ...state,
        financialAccountsCollapsed: {
          ...state.financialAccountsCollapsed,
          [financialAccountId]: collapsed,
        }
      }
    }
   
    default:
      return state
  }
}

export default financialAccounts



// WEBPACK FOOTER //
// ./src/reducers/financialAccounts.js